import PaintProductsWorkspace from '../../placeholders/PaintProductsWorkspace';

export default PaintProductsWorkspace;
